export const sanitizeHtml = (html) => {
  if (!html) return '';

  return html
    .replace(/<script.*?>.*?<\/script>/gi, '')
    .replace(/on\w+=".*?"/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/<[^>]+>/g, (tag) => {
      const allowed = ['p', 'strong', 'em', 'ul', 'li', 'ol', 'br', 'span', 'a'];
      const tagName = tag.match(/^<\/?(\w+)/)?.[1]?.toLowerCase();
      return allowed.includes(tagName) ? tag : '';
    });
}